import { __decorate, __metadata } from "tslib";
import { DocumentStatus } from '@cbbt/itf-onboarding-common';
import { BaseMessage, Field } from '@cbbt/lib-interface';
import { ALPHA_NUMERIC_WITH_UNDERSCORE_DASH } from '../../utils/regex.js';
import { DocumentDetail } from './DocumentDetail.js';
export class AttachmentDetailsRequest extends BaseMessage {
    uploadSequenceNo;
    evidenceTypeCode;
    documentCode;
    tmpSysFileRefNum;
    fileName;
    fileSize;
    contentType;
    status;
    previewCount;
    fileComments;
    createdBy;
    createdDate;
    updateDate;
    srcSessionId;
}
__decorate([
    Field.number({
        description: 'uploadSequenceNo',
        numberType: 'integer',
        required: true,
    }),
    __metadata("design:type", Number)
], AttachmentDetailsRequest.prototype, "uploadSequenceNo", void 0);
__decorate([
    Field.string({
        description: 'evidenceTypeCode',
        required: false,
    }),
    __metadata("design:type", String)
], AttachmentDetailsRequest.prototype, "evidenceTypeCode", void 0);
__decorate([
    Field.string({
        description: 'documentCode',
        required: false,
    }),
    __metadata("design:type", String)
], AttachmentDetailsRequest.prototype, "documentCode", void 0);
__decorate([
    Field.string({
        description: 'tmpSysFileRefNum',
        required: false,
    }),
    __metadata("design:type", String)
], AttachmentDetailsRequest.prototype, "tmpSysFileRefNum", void 0);
__decorate([
    Field.string({
        description: 'fileName',
        required: false,
    }),
    __metadata("design:type", String)
], AttachmentDetailsRequest.prototype, "fileName", void 0);
__decorate([
    Field.number({
        description: 'fileSize',
        numberType: 'integer',
        required: false,
    }),
    __metadata("design:type", Number)
], AttachmentDetailsRequest.prototype, "fileSize", void 0);
__decorate([
    Field.string({
        description: 'contentType',
        required: false,
    }),
    __metadata("design:type", String)
], AttachmentDetailsRequest.prototype, "contentType", void 0);
__decorate([
    Field.string({
        description: 'status',
        required: false,
    }),
    __metadata("design:type", String)
], AttachmentDetailsRequest.prototype, "status", void 0);
__decorate([
    Field.string({
        description: 'previewCount',
        required: false,
    }),
    __metadata("design:type", String)
], AttachmentDetailsRequest.prototype, "previewCount", void 0);
__decorate([
    Field.string({
        description: 'fileComments',
        required: false,
    }),
    __metadata("design:type", String)
], AttachmentDetailsRequest.prototype, "fileComments", void 0);
__decorate([
    Field.string({
        description: 'createdBy',
        required: false,
    }),
    __metadata("design:type", String)
], AttachmentDetailsRequest.prototype, "createdBy", void 0);
__decorate([
    Field.string({
        description: 'createdDate',
        required: false,
        format: 'date-time',
    }),
    __metadata("design:type", String)
], AttachmentDetailsRequest.prototype, "createdDate", void 0);
__decorate([
    Field.string({
        description: 'updateDate',
        required: false,
        format: 'date-time',
    }),
    __metadata("design:type", String)
], AttachmentDetailsRequest.prototype, "updateDate", void 0);
__decorate([
    Field.string({
        description: 'srcSessionId',
        required: false,
    }),
    __metadata("design:type", String)
], AttachmentDetailsRequest.prototype, "srcSessionId", void 0);
export class PartyDetailsRequest extends BaseMessage {
    casePartyID;
    externalSystemId;
    attachmentDetails;
}
__decorate([
    Field.number({
        description: 'casePartyID',
        required: true,
        numberType: 'integer',
    }),
    __metadata("design:type", Number)
], PartyDetailsRequest.prototype, "casePartyID", void 0);
__decorate([
    Field.number({
        description: 'externalSystemId',
        numberType: 'integer',
        required: false,
    }),
    __metadata("design:type", Number)
], PartyDetailsRequest.prototype, "externalSystemId", void 0);
__decorate([
    Field.array({
        required: false,
        items: {
            type: 'message',
            message: AttachmentDetailsRequest,
        },
    }),
    __metadata("design:type", Array)
], PartyDetailsRequest.prototype, "attachmentDetails", void 0);
export class CaseDetailsRequest extends BaseMessage {
    caseId;
    processCode;
    id;
    documentId;
    document;
    ocisEvidenceTypeCode;
    ocisEvidencePurposeCode;
    caseReferenceNo;
    caseStatus;
    journeyDocumentStatus;
    partyDetails;
    documentDetail;
}
__decorate([
    Field.number({
        description: 'Case id',
        required: true,
        numberType: 'integer',
    }),
    __metadata("design:type", Number)
], CaseDetailsRequest.prototype, "caseId", void 0);
__decorate([
    Field.string({
        description: 'ProcessCode',
        required: true,
        minLength: 1,
    }),
    __metadata("design:type", String)
], CaseDetailsRequest.prototype, "processCode", void 0);
__decorate([
    Field.string({
        description: 'documentId',
        required: true,
        format: 'uuid',
    }),
    __metadata("design:type", String)
], CaseDetailsRequest.prototype, "id", void 0);
__decorate([
    Field.string({
        required: false,
        description: 'Document Id',
        pattern: ALPHA_NUMERIC_WITH_UNDERSCORE_DASH,
    }),
    __metadata("design:type", String)
], CaseDetailsRequest.prototype, "documentId", void 0);
__decorate([
    Field.string({
        required: false,
        description: 'Document',
        minLength: 1,
    }),
    __metadata("design:type", String)
], CaseDetailsRequest.prototype, "document", void 0);
__decorate([
    Field.string({
        required: false,
        description: 'Ocis Evidence Type Code',
        minLength: 1,
    }),
    __metadata("design:type", String)
], CaseDetailsRequest.prototype, "ocisEvidenceTypeCode", void 0);
__decorate([
    Field.string({
        required: false,
        description: 'Ocis Evidence Purpose Code',
        minLength: 1,
    }),
    __metadata("design:type", String)
], CaseDetailsRequest.prototype, "ocisEvidencePurposeCode", void 0);
__decorate([
    Field.string({
        description: 'CaseReferenceNo',
        required: true,
        minLength: 1,
    }),
    __metadata("design:type", String)
], CaseDetailsRequest.prototype, "caseReferenceNo", void 0);
__decorate([
    Field.string({
        description: 'caseStatus',
        required: true,
        minLength: 1,
    }),
    __metadata("design:type", String)
], CaseDetailsRequest.prototype, "caseStatus", void 0);
__decorate([
    Field.enum({
        enum: DocumentStatus,
        description: 'Journey Document Status',
        required: false,
    }),
    __metadata("design:type", String)
], CaseDetailsRequest.prototype, "journeyDocumentStatus", void 0);
__decorate([
    Field.array({
        required: true,
        minItems: 1,
        items: {
            type: 'message',
            message: PartyDetailsRequest,
        },
    }),
    __metadata("design:type", Array)
], CaseDetailsRequest.prototype, "partyDetails", void 0);
__decorate([
    Field.message({
        required: false,
        description: 'Document details',
    }),
    __metadata("design:type", DocumentDetail)
], CaseDetailsRequest.prototype, "documentDetail", void 0);
//# sourceMappingURL=CaseDetailsRequest.js.map